class CustomSwiper extends HTMLElement {
  constructor() {
    super();
    this.sectionContainer = this.closest(".section-swiper");
    this.swiperButtonNext = this.sectionContainer.querySelector(
      ".swiper-button-next"
    );
    this.swiperButtonPrev = this.sectionContainer.querySelector(
      ".swiper-button-prev"
    );
    this.swiperScrollbar =
      this.sectionContainer.querySelector(".swiper-scrollbar");
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this, {
      slidesPerView: 1.5,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 4.2,
        },
      },
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      scrollbar: {
        el: this.swiperScrollbar,
      },
    });
  }
}
if (!customElements.get("custom-swiper")) {
  customElements.define("custom-swiper", CustomSwiper);
}
